const my = {
  routeName: {
    home: 'Halaman utama',
    stores: 'Lokasi',
    QR: 'Jana kod QR',
    transactionHistory: 'Sejarah transaksi',
    setting: 'Tetapan',
    adminManage: 'Admin management',
    logs: 'Rekod tukaran syiling',
  },
  logOut: {
    label: 'Log keluar',
    confirmTitle: 'Sahkan log keluar',
    confirmMessage: 'Adakah anda pasti mahu log keluar?',
  },
  openStore: {
    confirmTitle: 'Sedang mengemaskini status buka',
    confirmMessage:
      'Membuka lokasi bermaksud pelanggan boleh datang untuk tukaran syiling. Sila sahkan anda mahu membuka lokasi',
  },
  closeStore: {
    confirmTitle: 'Sedang mengemaskini status tutup',
    confirmMessage:
      'Menutup lokasi bermaksud pelanggan tidak boleh datang untuk tukaran syiling. Sila sahkan anda mahu menutup lokasi',
  },
  confirmActiveStore: {
    title: 'Active a location',
    message:
      'Location can login to the merchant website and coin conversion. Please confirm that you want to active a location',
  },
  confirmInactiveStore: {
    title: 'Deactivate a localtion',
    message:
      "Location can't login to the merchant website and coin conversion. Please confirm that you want to deactivate a location",
  },
  confirmTransferred: {
    title: 'Sahkan syiling diterima',
    message:
      'Pengesahan akan mengemas kini status transaksi menjadi SELESAI. Adakah anda mahu teruskan?',
  },

  address: 'Alamat',
  closed: 'Tutup',
  code: 'Kod',
  digit: 'Digit',
  email: 'Emel',
  endTime: 'Waktu Tutup',
  goBack: 'Kembali',
  language: 'Bahasa',
  open: 'Buka',
  password: 'Kata laluan',
  startTime: 'Waktu buka',
  storeID: 'ID lokasi',
  storeEmail: 'Emel lokasi',
  storeName: 'Nama lokasi',
  storePhone: 'Nombor telefon lokasi',
  storeLogo: 'Logo lokasi',
  selectFile: 'Pilih fail',
  storeAddress: 'Alamat lokasi',
  submit: 'Hantar',
  save: 'Simpan',

  monday: 'Isnin',
  tuesday: 'Selasa',
  wednesday: 'Rabu',
  thursday: 'Khamis',
  friday: 'Jumaat',
  saturday: 'Sabtu',
  sunday: 'Ahad',

  coinDeposit: 'TUKARAN SYILING',
  status: 'STATUS',
  success: 'BERJAYA',
  transactionId: 'ID TRANSAKSI',
  clientFullName: 'NAMA PENUH PELANGGAN',
  clientPhoneNumber: 'NOMBOR TELEFON BIMBIT PELANGGAN',
  timeCreated: 'MASA DICIPTA',
  transactionFee: 'TCAJ TRANSAKSI',
  back: 'KEMBALI',
  depositAmount: 'Jumlah syiling (RM)',
  amount: 'JUMLAH (RM)',
  coinDepositAmount: 'Jumlah syiling (RM)',
  confirmGenerateQrCode: (amount) =>
    `Penukaran syiling kepada RM${amount}. Jana kod QR?`,
  pleaseInputAmountRM: 'Sla masukkan jumlah (RM)',
  generateQrCode: 'Sediakan kod QR',
  expiresIn: 'Luput dalam masa',
  qrCodeExpired: 'KOD QR LUPUT',
  regenerateQrCode: 'Jana kod QR yang baru',
  changeAmount: 'Tukar jumlah',
  createTransactionSuccess: 'Transaksi dimulakan',
  depositTimestamp: 'Masa tukaran',

  id: 'ID',
  phoneNumber: 'Nombor telefon bimbit',
  customerName: 'Nama pelanggan',
  help: 'Bantuan',
  requestHelp: 'Mohon bantuan',
  timeAt: 'Masa',
  dateRange: 'Tempoh',
  updateSettingsSuccess: 'Tetapan telah dikemaskini',
  resendEmail: 'Hantar semula emel',
  emailVerifySent:
    'Kod 6-digit telah dihantar kepada anda melalui emel dan SMS.',
  latitude: 'Latitud',
  longitude: 'Longitud',
  miniumAmountRequired: 'Jumlah minimum yang diperlukan',
  locationSetting: 'Tetapan lokasi',
  needHelp: 'Perlu bantuan?',
  tooltipFindLatitude: 'Cari atau masukkan latitud dan longitud',
  createStore: 'Cipta lokasi',
  editStore: 'Ubah suai lokasi',
  storeNotFound: 'Lokasi tidak dijumpai',
  backToListStore: 'Kembali ke senarai lokasi',
  action: 'Tindakan',
  transferred: 'Syiling diterima',
  export: 'Eksport',
  transactionDetail: 'Butiran transaksi',
  sendTo: 'Hantar kepada',
  charity: 'Charity',
  bank: 'Bank',
  bankAccountName: 'Nama pemegang akaun bank',
  bankAccountNumber: 'Nombor akaun bank',
  transactionStatus: 'Status transaksi',
  bankName: 'Nama bank',
  search: 'Cari',
  resetFilter: 'Set semula tapisan',
  login: 'Log masuk',
  verifyEmail: 'Sahkan alamat emel',
  changeOnlineHours: 'Kemaskini waktu operasi',
  clickToAddTimeSlot: 'Klik sini untuk tambah slot waktu yang baru bagi hari',
  clickHereToOnline: 'Klik di sini untuk membuka lokasi',
  offline: 'Tutup',
  online: 'Buka',
  active: 'Aktif',

  forgotPassword: 'Lupa kata laluan?',
  account: 'Akaun',
  changePassword: 'Ubah kata laluan',
  currentPassword: 'Kata laluan kini',
  newPassword: 'Kata laluan baharu',
  confirmNewPassword: 'Sahkan kata laluan baharu',
  passwordNotMatch: 'Kata laluan baharu tidak sepadan',
  changePasswordSuccess: 'Kata laluan berjaya diubah',
  backToLogin: 'Kembali ke log masuk',
  forgotPass: {
    emailSent: 'Semak emel anda',
    message1: 'Emel telah dikirim kepada',
    message2: 'Ikuti arahan dalam emel untuk set semula kata laluan anda',
    messageEnterMail:
      'Masukkan alamat emel anda. Kami akan mengirim pautan untuk set semula kata laluan anda',
  },
  resetPassword: 'Set semula kata laluan',
  continue: 'Teruskan',

  createAdmin: 'Cipta admin',
  fullName: 'Nama penuh',
  role: 'Peranan',
  admin: 'Admin',
  superAdmin: 'Super admin',
  createSuccess: 'Berjaya dicipta',
  sendInvitationEmail: 'Hantar emel undangan',
  objSendInvitation: {
    title: 'Hantar emel undangan kepada lokasi',
    content: 'Anda akan menghantar emel undangan. Teruskan?',
    success: 'Emel undangan berjaya dihantar',
    error1: 'Tidak dapat menghantar emel kepada ',
    btnReSend: 'Hantar semula emel',
    sendingEmail: 'Emel sedang dihantar',
  },
  objExportError: {
    title: 'Ralat data',
    isDone: 'Transaksi SELESAI',
    isMissingData: 'Data tak lengkap dalam transaksi',
    isConfirmed: 'Transaksi DISAHKAN',
  },
  wantToContinue: 'Teruskan?',
  exportBulkPayment: 'Eksport untuk Bayaran Pukal',
  requestBody: 'Request Body',
  responseMessage: 'Response message',
  statusCode: 'Status code',
  api: 'API',
  createdAt: 'Created at',
  adminNotFound: 'Admin tidak dijumpai',
  backToAdminManage: 'Kembali kepada pengurusan admin',
  confirmInactiveAdmin: {
    title: 'Nyahaktifkan akaun admin',
    message:
      'Akaun ini akan dilog keluar daripada semua peranti dan tidak dapat log masuk semula. Teruskan?',
  },
  confirmActiveAmin: {
    title: 'Active an admin account',
    message: 'Akaun ini boleh log masuk ke halaman ini. Teruskan?',
  },
  editAdmin: 'Ubah suai admin',
  updateSuccess: 'Kemaskini berjaya',
  waitingTransfer: 'Waiting for transfer',
  coinReceived: 'Coin received',
  paid: 'Paid',
  requesthelpTitle: 'REQUEST HELP FOR THIS TRANSACTION',
};

export default my;
